import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from "@mui/x-data-grid";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl} from "../Univ.js";
function TeleConsView(props) {
    // =====================================================
    // DATE
    // =====================================================
    const [selectedDate, setSelectedDate] = useState(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000));
    // =====================================================
    // DATA
    // =====================================================
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    // =====================================================
    // FETCH WHEN DATE CHANGES
    // =====================================================
    useEffect(() => {
        fetchData();
        const intervalId = setInterval(fetchData, 12000);
        return () => {
            clearInterval(intervalId);
        };
    }, [selectedDate]);
    // =====================================================
    // FETCH APPOINTMENTS
    // =====================================================
    const fetchData = () => {
        setIsLoading(true);
        // -------------------------------------------------
        // FORMAT DATE
        // -------------------------------------------------
        const formattedDate = selectedDate
            .toISOString()
            .substring(0, 10);
        console.log("TELEMEDICINE DATE:", formattedDate);
        // -------------------------------------------------
        // API
        // -------------------------------------------------
        axios
            .get(`${baseUrl}telemedicine/doctor/appointments/${formattedDate}/`)
            .then((response) => {
                console.log("TELEMEDICINE API RESPONSE:", response.data);
                // =========================================
                // API RESPONSE
                // =========================================
                //
                // {
                //     success: true,
                //     date: "...",
                //     doctor: {...},
                //     appointments: [...]
                // }
                //
                // =========================================
                if (response.data && response.data.success) {
                    const appointments = response.data.appointments || [];
                    console.log("APPOINTMENTS:", appointments);
                    // =====================================
                    // SET DATAGRID ROWS
                    // =====================================
                    setRows(appointments.map((appointment) => ({
                        ...appointment, // DataGrid requires a unique id
                        id: appointment.id
                    })));
                } else {
                    setRows([]);
                }
                setIsLoading(false);
            })
            .catch((error) => {
                console.error("TELEMEDICINE APPOINTMENT ERROR:", error);
                setRows([]);
                setIsLoading(false);
            });
    };
    // =====================================================
    // DATE CHANGE
    // =====================================================
    const handleDateChange = (date) => {
        if (!date) {
            return;
        }
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setSelectedDate(localDate);
    };
    // =====================================================
    // FORMAT APPOINTMENT DATE
    // =====================================================
    const formatAppointmentDate = (value) => {
        if (!value) {
            return "";
        }
        const date = new Date(value);
        return date.toLocaleString("en-IN", {
            day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true
        });
    };
    // =====================================================
    // DATAGRID COLUMNS
    // =====================================================
    const columns = [{
        field: "id", headerName: "Appt ID", width: 100
    }, {
        field: "patient_number", headerName: "Patient ID", width: 140
    }, {
        field: "patient_name", headerName: "Patient", width: 220
    }, {
        field: "appointment_date", headerName: "Appointment Slot", width: 210, renderCell: (params) => (<span>
                    {formatAppointmentDate(params.value)}
                </span>)
    }, {
        field: "status", headerName: "Status", width: 130, renderCell: (params) => (<span
            className={params.value === "scheduled" ? "badge bg-success" : "badge bg-secondary"}
        >
                    {params.value}
                </span>)
    }, {
        field: "action",
        headerName: "Action",
        width: 160,
        sortable: false,
        filterable: false,
        renderCell: (params) => (<button
            type="button"
            className="btn btn-success"

            onClick={() => {
                // =================================
                // TELEMEDICINE ROLE
                // =================================
                localStorage.setItem("telemedicine_role", "doctor");
                // =================================
                // OPEN TELEMEDICINE ROOM
                // =================================
                window.location.href = `/telemedicine-room/${params.row.id}`;
            }}
        >

            <i className="fa-solid fa-video me-2"></i>

            Join

        </button>)
    }];
    // =====================================================
    // RENDER
    // =====================================================
    return (<section className="container mt-4">

        {/* =========================================
                DATE SELECTOR
            ========================================= */}

        <div className="row">

            <div className="col-md-6">

                <div className="form-group">

                    <label className="control-label mb-2">

                        Select Date

                    </label>

                    <DatePicker

                        selected={selectedDate}

                        onChange={handleDateChange}

                        dateFormat="dd/MM/yyyy"

                        className="form-control"

                    />

                </div>

            </div>

        </div>


        {/* =========================================
                LOADING
            ========================================= */}

        {isLoading && (<div className="text-center mt-4">

            <div
                className="spinner-border text-primary"
                role="status"
            />

            <div className="mt-2">

                Loading appointments...

            </div>

        </div>)}


        {/* =========================================
                NO APPOINTMENTS
            ========================================= */}

        {!isLoading && rows.length === 0 && (<div className="alert alert-info mt-4">

            <i className="fa-solid fa-calendar-xmark me-2"></i>

            No telemedicine appointments
            available for the selected date.

        </div>)}


        {/* =========================================
                DATAGRID
            ========================================= */}

        {!isLoading && rows.length > 0 && (<div
            style={{
                width: "100%"
            }}
            className="mt-4"
        >

            <DataGrid

                rows={rows}

                columns={columns}

                autoHeight

                pageSizeOptions={[10, 25, 50]}

                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 10, page: 0
                        }
                    }
                }}

                slots={{
                    toolbar: GridToolbar
                }}

                disableRowSelectionOnClick

                sx={{
                    boxShadow: 4, border: 1, borderColor: "primary.light", "& .MuiDataGrid-cell:hover": {
                        color: "primary.main"
                    }
                }}

            />

        </div>)}

    </section>);
}
export default TeleConsView;